import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/views/layout' // 母视图
import home from '@/views/home/home.vue'

import { getToken } from '@/utils/cookies.js'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'layout',
    component: layout,
    children: [
      {
        path: '/',
        redirect: '/home'
      },
      // 首页
      {
        path: '/home',
        name: 'home',
        component: home,
        meta: { title: '嘉宏集团' }
      },
      // 嘉宏介绍
      {
        path: '/about',
        name: 'about',
        component: () => import('@/views/home/about.vue'),
        meta: { title: '嘉宏介绍' }
      },
      // 企业荣誉
      {
        path: '/honor',
        name: 'honor',
        component: () => import('@/views/home/honor.vue'),
        meta: { title: '企业荣誉' }
      },
      //  发展历程
      {
        path: '/visioncar',
        name: 'visioncar',
        component: () => import('@/views/home/visioncar.vue'),
        meta: { title: '发展历程' }
      },
      // 企业文化
      {
        path: '/corporate',
        name: 'corporate',
        component: () => import('@/views/home/corporate.vue'),
        meta: { title: '企业文化' }
      },
      {
        path: '/corplist',
        name: 'corplist',
        component: () => import('@/views/home/corplist.vue'),
        meta: { title: '企业文化' }
      },
      {
        path: '/corpdetail',
        name: 'corpdetail',
        component: () => import('@/views/home/corpdetail.vue'),
      },
      // 企业文化详情页
      {
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/home/ndetail.vue')
      },
      // 新闻中心
      {
        path: '/news',
        name: 'news',
        component: () => import('@/views/home/news.vue'),
        meta: { title: '新闻中心' }
      },
      {
        path: '/ndetail',
        name: 'ndetail',
        component: () => import('@/views/home/ndetail.vue')
      },
      {
        // 住宅开发
        path: '/dwell',
        name: 'dwell',
        component: () => import('@/views/poly/dwell'),
        meta: { title: '住宅开发' }
      },
      {
        // 商业运营
        path: '/business',
        name: 'business',
        component: () => import('@/views/poly/business'),
        meta: { title: '商业运营' }
      },
      {
        // 商业运营
        path: '/busdetail',
        name: 'busdetail',
        component: () => import('@/views/poly/busdetail')
      },
      {
        // 酒店管理
        path: '/hotel',
        name: 'hotel',
        component: () => import('@/views/poly/hotel'),
        meta: { title: '酒店管理' }
      },
      {
        // 物业服务
        path: '/real',
        name: 'real',
        component: () => import('@/views/poly/real'),
        meta: { title: '物业服务' }
      },
      {
        // 风华荟
        path: '/elegance',
        name: 'elegance',
        component: () => import('@/views/service/elegance'),
        meta: { title: '风华荟' }
      },
      {
        // 服务中心
        path: '/service',
        name: 'service',
        component: () => import('@/views/service/service'),
        meta: { title: '客服中心' }
      },
      {
        // 以旧换新
        path: '/exchange',
        name: 'exchange',
        component: () => import('@/views/extra/exchange'),
        meta: { title: '以旧换新' }
      },
      {
        // 预约看房
        path: '/apply',
        name: 'apply',
        component: () => import('@/views/extra/apply'),
        meta: { title: '预约看房' }
      },
      {
        // 加入嘉宏
        path: '/join',
        name: 'join',
        component: () => import('@/views/extra/join'),
        meta: { title: '加入嘉宏' }
      },
      {
        // 加入嘉宏
        path: '/joindetail',
        name: 'joindetail',
        component: () => import('@/views/extra/joindetail'),
        meta: { title: '加入嘉宏' }
      }
    ]
  }
]
const router = new VueRouter({
  mode: "hash",
  routes: [
    ...routes
  ],
  scrollBehavior (to, from, savedPosition) {
    // 如果指定了savedPosition，则使用保存的位置
    if (to.fullPath.indexOf('isSixMode')!=-1) {
      return {}
    } else {
      // 对于不需要滚动行为的页面，返回空对象
      return savedPosition || { x: 0, y: 0 }
    }
  }
})
// router.beforeEach((to, from, next) => {
//   console.log('beforeEach')
//   // cookie没有值就跳到登陆页
//   // let token = getToken()
//   // console.log('tt==',token)
//   // if (token === undefined && to.name !== 'login' && to.name !== 'overview') {
//   //   Vue.prototype.$message.error('用户未登陆')
//   //   next('/login')
//   // } else {
//     next()
//   // }
// })
// 加入百度统计
router.beforeEach((to, from, next) => {
  // 如果路由meta中有title字段，则设置文档标题
  var title = '嘉宏集团'
  if (to.meta && to.meta.title) {
    title = to.meta.title;
  }
  // if(title != '嘉宏集团'){
  //   title = title + '_嘉宏集团'
  // }
  document.title = title
  // document.querySelector('meta[property="og:title"]').setAttribute('content', '新标题');
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})
// 解决跳转到当前路由报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
